import React from 'react'
import { Link } from 'gatsby'
import Icon from 'shared/ui/Icon'
import { IconContent, IconContentText } from 'shared/ui/IconContent'

export default function WorkshopIntroStream() {
  return (
    <section className="offset-slant-background-image-left">
      <ul className="list-reset spacing">
        <IconContent as="li" className="spacing-xsmall">
          <IconContentText size={1.3}>
            <Icon name="check-circle" size={1.3} color="brightBlue" />
            <strong>Mini Workshop</strong>
          </IconContentText>
          <p>
            Come learn a specific React topic in our free "mini workshops" that take place about 1-2
            times per month. Each can range from about 60 to 90 minutes.
          </p>
        </IconContent>
        <IconContent as="li" className="spacing-xsmall">
          <IconContentText size={1.3}>
            <Icon name="check-circle" size={1.3} color="brightBlue" />
            <strong>Live Coding</strong>
          </IconContentText>
          <p>
            The instructor will live-code all examples and will help you understand nuances of best
            practices.
          </p>
        </IconContent>
        <IconContent as="li" className="spacing-xsmall">
          <IconContentText size={1.3}>
            <Icon name="check-circle" size={1.3} color="brightBlue" />
            <strong>What's next?</strong>
          </IconContentText>
          <p>
            Let us know what other topics you want to see, or if we can do a workshop{' '}
            <Link to="/corporate-training">for your company.</Link>
          </p>
        </IconContent>
      </ul>
    </section>
  )
}
